<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <section id="valeurs" class="screen secondary">
        <CommonShapeAnimation shape="circle" position="right" />
        <div class="content">
            <div class="wrapper">
                <div class="intro">
                    <h2>Nos valeurs</h2>
                    <p>Nos valeurs sont là pour façonner des collaborations authentiques et inspirantes, où vos idées
                        prennent vie. Envie de bâtir une histoire qui vous ressemble ?</p>
                    <a id="values-header-action" @click="clickHandler('header', 'contact')" title="Contactez-nous">
                        <CommonButton color="secondary" size="large" icon="next">Je me lance</CommonButton>
                    </a>
                </div>
                <div class="grid-3">
                    <article class="panel">
                        <header>
                            <IconEar />
                            <h3>Écoute</h3>
                        </header>
                        <p><strong>L’écoute, première pierre de la réussite.</strong></p>
                        <p class="grow">Comprendre vos attentes, vos ambitions et vos défis est la clé d’un projet
                            réussi. Notre approche collaborative transforme vos idées en véritables inspirations.</p>
                        <a id="values-listen" @click="clickHandler('listen', 'contact')" title="Contactez-nous">
                            <CommonButton icon="next">Je me lance</CommonButton>
                        </a>
                    </article>
                    <article class="panel">
                        <header>
                            <IconMind />
                            <h3>Créativité</h3>
                        </header>
                        <p><strong>Imaginer au-delà des limites.</strong></p>
                        <p class="grow">Nous transformons vos idées en concepts uniques et audacieux. Notre mission :
                            innover avec élégance pour faire émerger des projets qui marquent les esprits et se
                            démarquent de l’ordinaire.</p>
                        <a id="value-create" @click="clickHandler('create', 'contact')" title="Contactez-nous">
                            <CommonButton icon="next">Je me lance</CommonButton>
                        </a>
                    </article>
                    <article class="panel">
                        <header>
                            <IconInovation />
                            <h3>Innovation</h3>
                        </header>
                        <p><strong>Rester en avance pour ouvrir de nouvelles perspectives.</strong></p>
                        <p class="grow">Nous adoptons les dernières technologies et tendances pour réinventer les codes.
                            Parce qu’être innovant, c’est offrir plus qu’une solution : c’est ouvrir la voie à de
                            nouvelles opportunités.</p>
                        <a id="value-innovate" @click="clickHandler('innovate', 'contact')" title="Contactez-nous">
                            <CommonButton icon="next">Je me lance</CommonButton>
                        </a>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import IconEar from "@/components/icons/IconEar.vue";
import IconMind from "@/components/icons/IconMind.vue";
import IconInovation from "@/components/icons/IconInovation.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";

const clickHandler = (origin: string, destination: string) => {
    trackButtonClick(`values-${origin}-${destination}`);
    scrollToSection(destination);
}
</script>

<style lang="sass">
</style>